import { FontIcon, FontIconColors, FontIcons } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import { PrivacySettingsColors } from './colors';
import { AlertProps } from './types';

// ===== STYLED COMPONENTS =====

const AlertContainer = styled.div`
  border-radius: 8px;
  background: ${PrivacySettingsColors.ErrorBackground};
  padding: 16px 8px 16px 12px;
  margin: 10px 0 20px 0;
  display: flex;
  align-items: flex-start;
`;

const AlertIcon = styled(FontIcon)`
  margin-right: 8px;
  margin-top: 2px;
`;

const AlertMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AlertHeader = styled.div`
  font-size: 14px;
  color: ${PrivacySettingsColors.ErrorText};
  margin-bottom: 8px;

  .bff-private {
    margin-right: 8px;
    font-size: 18px;
  }
`;

const AlertMessage = styled.div`
  p {
    font-size: 13px;
    margin-bottom: 4px;
  }

  button {
    margin-right: 5px;
  }
`;

const UpdatePasskeyLink = styled.button`
  background: none;
  border: none;
  color: ${PrivacySettingsColors.PurplePopsicle};
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  font-weight: 600;
`;

// ===== MAIN COMPONENT =====

/**
 * Generic alert component for displaying passkey-related warnings and information
 * Can be reused for different types of alerts with different messages and actions
 */
const Alert: React.FunctionComponent<AlertProps> = ({
  headerText,
  messageLines,
  showUpdateButton = true,
  onUpdateClick
}) => {
  return (
    <AlertContainer role="alert">
      <AlertIcon aria-hidden color={FontIconColors.Danger} icon={FontIcons.Warning} />
      <AlertMessageContainer>
        <AlertHeader>
          {headerText}
        </AlertHeader>
        <AlertMessage>
          {messageLines.map((line, index) => (
            <p key={index}>
              {line.includes('UPDATE_BUTTON') && showUpdateButton ? (
                <>
                  <UpdatePasskeyLink
                    onClick={onUpdateClick}
                    type="button"
                  >
                    <Trans>Update passkey</Trans>
                  </UpdatePasskeyLink>
                  {line.replace('UPDATE_BUTTON', '')}
                </>
              ) : (
                line
              )}
            </p>
          ))}
        </AlertMessage>
      </AlertMessageContainer>
    </AlertContainer>
  );
};

export default Alert;
